export default "__VITE_ASSET__6jnS_B1z__"